import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';
import { convertNum, SwapStatus } from 'src/app/shared/constants/app-enums';
import { PopupService } from 'src/app/services/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { ConnectComponent } from '../connect/connect.component';
// import { WertComponent } from '../wert/wert.component';
import { SwapComponent } from 'src/app/components/swap/swap.component';

@Component({
  selector: 'app-buy-stake',
  templateUrl: './buy-stake.component.html',
  styleUrls: ['./buy-stake.component.scss']
})
export class BuyStakeComponent {
  @Input() isNative: boolean = true;
  @Input() isWert: boolean = false;
  @ViewChild(SwapComponent) swapComp: any;
  isStake = false;
  swapToken!: any;
  baseToken!: any;
  minAmount = 100;
  nativeBal: number = 0;
  isLowBalance = false;
  minWert = '$20';
  lowGas = false;
  swapMode: string = 'native';
  isWeb3: boolean = false;

  token = environment.tokenName;
  gasFeesETH: number = environment.eth.gasFees; //0.015;
  gasFeesBSC: number = environment.bsc.gasFees; //0.0025;
  usdtBal: number = 0;
  salePrice: number = 0.0337;
  tokenSold = 0;
  SwapStatus = SwapStatus;

  constructor(
    public modalRef: BsModalRef,
    private walletConnect: WalletConnectService,
    private eventService: EventService,
    private modalService: BsModalService,
    private popupService: PopupService,
    private translate: TranslateService,
  ) {

  }

  ngOnInit() {
  }
  connectModal(): void {

    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static'
    });
  }

  openSwap(isNative: boolean = true, isEth: boolean = false): void {
    if (this.swapComp?.wertMode) {
      this.popupService.messagePopup("warning", "", "Are you sure you want to change?", "Confirm", "Cancel").then((result: any) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.swapComp!.wertMode = false;
          this.swapMode = isNative ? 'native' : isEth ? 'eth' : 'usdt';
          this.isNative = isNative;
          // this.isWert = isEth;
        }
      });
    } else {
      this.swapMode = isNative ? 'native' : isEth ? 'eth' : 'usdt';
      this.isNative = isNative;
      // this.isWert = isEth;
    }
    setTimeout(() => this.swapComp!.max(), 1000)
  }

  isCorrectChain() {
    return this.walletConnect.isCorrectChain()
  }

  get walletAddress(): any {
    return this.walletConnect.walletAddress;
  }

  get dataLoaded() {
    return this.tokenSold > 0;
  }

  checkChain(): boolean {
    if (this.isCorrectChain()) {
      return true;
    } else {
      if (this.walletConnect.mode == "wallet") {
        this.walletConnect.switchNetwork(this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt).then(() => {
          return true;
        })
        return true;
      } else {
        this.popupService.messagePopup(
          "info",
          this.translate.instant('wrong_chain', { chainName: this.eventService.isBsc ? environment.bsc.chainName : environment.eth.chainName }),
          this.translate.instant('change_network'))
          .then((res) => {
            if (res.isConfirmed) {
              this.walletConnect.switchNetwork(this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt);
            }
          });
        return false;
      }
    }
  }
  get gasFees() {
    return this.isBsc ? this.gasFeesBSC : this.gasFeesETH;
  }
  get isBsc() {
    return this.eventService.isBsc;
  }

  get status() {
    return this.walletConnect.swapStatus;
  }

  confirm(isStake = false) {
    this.isStake = isStake;

    if (!this.walletConnect.referUrl || this.walletConnect.referUrl == '') {
      this.walletConnect.refer();
    }
    if (this.checkChain()) {
      // if (this.isWert) {
      //   if (!this.swapToken || this.swapToken < 20) {
      //     this.popupService.messagePopup("error", this.translate.instant('wert_min_warking', { minWert: this.minWert, token: this.token }),
      //       this.translate.instant('confirm')
      //     );
      //   } else {
      //     this.modalRef = this.modalService.show(WertComponent, {
      //       class: 'modal-xs modal-dialog-centered transak',
      //       backdrop: 'static',
      //       initialState: { walletAddress: this.walletAddress, baseToken: this.baseToken }
      //     });
      //   }
      // } else {
      if (this.swapToken !== 0 && this.baseToken >= this.minAmount) this.createSwap(isStake);
      // }
    }
  }

  async createSwap(isStake = false) {

    this.walletConnect.swapStatus = SwapStatus.not_started;
    try {
      if (this.isNative) {
        if ((this.nativeBal - this.gasFees) >= this.swapToken) {
          this.isLowBalance = false;
          if (this.isBsc) {
            await this.walletConnect.swapBnbTokens(this.baseToken, this.swapToken);
          } else {
            await this.walletConnect.swapEthTokens(this.baseToken, this.swapToken, isStake);
          }
        } else {
          this.isLowBalance = true;
        }
      } else {
        if (this.usdtBal >= this.swapToken && this.nativeBal >= this.gasFees) {
          this.isLowBalance = false;
          await this.walletConnect.swapCryptoForUSDT(this.baseToken, this.swapToken, false, isStake);
        } else {
          this.isLowBalance = true;
          if (this.nativeBal < this.gasFees)
            this.lowGas = true;
        }
      }
    }
    catch (err: any) {
      console.log('createSwap', err);
      if (err && err.code == 4001) {
        this.walletConnect.swapStatus = SwapStatus.rejected;
      } else {
        this.walletConnect.swapStatus = SwapStatus.failed;
      }
    }
  }

}
